export default __webpack_public_path__ + "static/DunfermerlineKings-04f8391d9865e8898fb546df9e6d1a96.png";